var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-edit-navigator"},[_c('button',{staticClass:"register important",attrs:{"disabled":!_vm.isRegisterable},on:{"click":function($event){return _vm.registerDocument()}}},[_vm._v("登録")])])}
var staticRenderFns = []

export { render, staticRenderFns }